import React, { FC } from 'react';
import MuiListSubheader, { ListSubheaderProps as MuiListSubheaderProps } from '@mui/material/ListSubheader';
import { BpDesignSystem } from '../../types';

export type ListSubHeaderProps = BpDesignSystem.PropsWithChildren<MuiListSubheaderProps & {}>;

export const ListSubHeader: FC<ListSubHeaderProps> = ({ dataTest, ...props }) => (
  <MuiListSubheader data-test={dataTest} {...props} />
);
